import { GET_STOCK_STYLE_ERROR, GET_STOCK_STYLE_REQUEST, GET_STOCK_STYLE_SUCCESS } from "../actions/types"
export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {

        case GET_STOCK_STYLE_REQUEST:
            return {
                loading: true,
            };
        case GET_STOCK_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_STOCK_STYLE_ERROR:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}